import { collection, onSnapshot } from 'firebase/firestore'
import { ref, watchEffect } from 'vue'
import firebase from '../../firebase'

const getCollection = (collectionName, query) => {
  const error = ref('')
  const documents = ref(null)
  if (!query) {
    query = collection(firebase.db, collectionName)
  }
  const unsubscribe = onSnapshot(
    query,
    (snapshot) => {
      const items = []
      snapshot.forEach((doc) => {
        items.push({ ...doc.data(), id: doc.id })
      })
      documents.value = items
      error.value = ''
    },
    (err) => {
      documents.value = null
      error.value = err.message
    }
  )

  watchEffect((onInvalidate) => {
    onInvalidate(() => unsubscribe())
  })

  return { error, documents }
}

export default getCollection
